import { IClientHelper } from "../Interfaces/IClientHelper";

export enum CallType {
  Create,
  Read,
  Update,
  Delete
}

export class ErrorDefaults {
  badRequest: string;
  notFound: string;
  internalServerError: string;
}

export class ErrorMessageBuilder {
  private defaults: ErrorDefaults;
  private showTechnicalError = false;

  constructor(type: CallType, private readonly clientHelper: IClientHelper) {
    switch (type) {
      default:
        this.defaults = {
          badRequest: "Door een storing kunnen er geen resultaten worden getoond.",
          notFound: "Er zijn geen resultaten gevonden.",
          internalServerError: "Door een storing kunnen er geen resultaten worden getoond."
        };
        break;
    }
  }

  setMessages = (errors: ErrorDefaults): ErrorMessageBuilder => {
    this.defaults = errors;

    return this;
  };

  setShowTechnicalError = (showTechnicalError: boolean): ErrorMessageBuilder => {
    this.showTechnicalError = showTechnicalError;

    return this;
  };

  build = (reason: any): string => {
    if (!this.clientHelper.containsStatusCode(reason)) {
      return this.defaults.internalServerError;
    }

    let pattern = `[error] ${this.showTechnicalError ? " ([technical])" : ""}`;

    switch (reason.status) {
      case 400:
        pattern = pattern.replace("[error]", this.defaults.badRequest);
        break;
      case 404:
        pattern = pattern.replace("[error]", this.defaults.notFound);
        pattern = pattern.replace("([technical])", "");
        break;
      default:
        pattern = pattern.replace("[error]", this.defaults.internalServerError);
        break;
    }

    if (pattern.indexOf("[technical") > 0) {
      pattern = pattern.replace("[technical]", this.clientHelper.getTechnicalErrorMessage(reason) ?? "");
    }

    return pattern.replace("()", "").trim();
  };
}
